(() => {
  const elementName = 'pdp-v2-buy-box';

  if (customElements.get(elementName)) {
    return;
  }

  class PdpV2BuyBox extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;
      this.handleOptionChange = this.handleOptionChange.bind(this);
      this.options = Array.from(this.querySelectorAll('[data-pdp-v2-bundle-option]'));
      this.cta = this.querySelector('[data-pdp-v2-bundle-cta]');
      this.variantAvailable = this.dataset.variantAvailable === 'true';

      this.options.forEach((option) => {
        option.addEventListener('change', this.handleOptionChange);
      });

      const selectedOption = this.options.find((option) => option.checked) || this.options[0];

      if (selectedOption) {
        selectedOption.checked = true;
        this.updateFromOption(selectedOption);
      }
    }

    disconnectedCallback() {
      if (!this.options) {
        return;
      }

      this.options.forEach((option) => {
        option.removeEventListener('change', this.handleOptionChange);
      });

      this.options = null;
      this.cta = null;
      this.initialized = false;
    }

    handleOptionChange(event) {
      const option = event.target;

      if (!option || !option.matches('[data-pdp-v2-bundle-option]')) {
        return;
      }

      this.updateFromOption(option);
    }

    updateFromOption(option) {
      const {
        quantity,
        unitPriceFormatted,
        finalTotalFormatted,
        originalTotalFormatted,
        savingsFormatted,
        totalSavingsCents,
      } = option.dataset;
      const hasSavings = Number(totalSavingsCents || 0) > 0;

      this.dataset.selectedQuantity = quantity || '';
      this.updateSelectionState(option);
      this.setText('[data-pdp-v2-bundle-selected-quantity]', quantity);
      this.setText('[data-pdp-v2-bundle-unit-output]', unitPriceFormatted);
      this.setText('[data-pdp-v2-bundle-savings-output]', hasSavings ? savingsFormatted : '');
      this.setText('[data-pdp-v2-bundle-cta-final]', finalTotalFormatted);
      this.setText('[data-pdp-v2-bundle-cta-original]', hasSavings ? originalTotalFormatted : '');

      const quantityInput = this.querySelector('[data-pdp-v2-bundle-quantity]');
      if (quantityInput) {
        quantityInput.value = quantity || '1';
      }

      const originalOutput = this.querySelector('[data-pdp-v2-bundle-cta-original]');
      if (originalOutput) {
        originalOutput.hidden = !hasSavings;
      }

      if (this.cta) {
        this.cta.disabled = !this.variantAvailable;
      }
    }

    updateSelectionState(selectedOption) {
      this.options.forEach((option) => {
        const optionWrapper = option.closest('.pdp-v2-bundle__option');
        const optionLabel = option.nextElementSibling;
        const isSelected = option === selectedOption;

        if (optionWrapper) {
          optionWrapper.classList.toggle('pdp-v2-bundle__option--selected', isSelected);
        }

        if (optionLabel && optionLabel.matches('[data-pdp-v2-bundle-label]')) {
          optionLabel.classList.toggle('pdp-v2-bundle__label--selected', isSelected);
        }
      });
    }

    setText(selector, value) {
      const output = this.querySelector(selector);

      if (!output) {
        return;
      }

      output.textContent = value || '';
    }
  }

  customElements.define(elementName, PdpV2BuyBox);
})();
